import { Box, Button } from "@mui/material";
import Types from "prop-types";
import React from "react";
import ModalCustom from "@components/ModalCustom";

const ModalBase = ({
  handleSuccess = () => {},
  showButtonCancel = true,
  showButtonSuccess = true,
  handleClose = () => {},
  buttonText = "OK",
  cancelText = "戻る",
  children,
  ...props
}) => {
  return (
    <ModalCustom {...props} handleClose={handleClose}>
      {children}
      <Box className="d-flex pb-3 mt-3">
        {showButtonCancel && (
          <Button fullWidth className="btn jvs-btn-gray mx-1" onClick={handleClose}>
            {cancelText}
          </Button>
        )}
        {showButtonSuccess && (
          <Button fullWidth className="btn jvs-btn-cyan mx-1" onClick={handleSuccess}>
            {buttonText}
          </Button>
        )}
      </Box>
    </ModalCustom>
  );
};

ModalBase.propTypes = {
  handleSuccess: Types.func,
  handleClose: Types.func,
  buttonText: Types.string,
  cancelText: Types.string,
  children: Types.node,
  showButtonCancel: Types.bool,
  showButtonSuccess: Types.bool,
};

export default ModalBase;
